'use client';
import { SectionContainer } from '../component/SectionContainer';
import Marquee from 'react-fast-marquee';
import { useLocale } from 'use-intl';
import { useMemo, useRef } from 'react';
import { IAiForGoodItem } from '../type';
import { getCMSIntlVal } from '../utils/common';
import CustomScrollBar from '../component/CustomScrollBar';
import { useMedia, useWechat } from '@ssv-website/hooks';
import Image from '../../../image';

const AiForGoodItem = ({
  item,
  className,
}: {
  item: IAiForGoodItem;
  className?: string;
}) => {
  const locale = useLocale();
  const { logo, link, mobileLink, wxLink } = item || {};
  const isMobile = useMedia('mobile');
  const caseText = getCMSIntlVal(item, 'caseText', locale);
  const { isWechat } = useWechat();
  const jumpLink = isWechat ? wxLink : isMobile ? mobileLink : link;
  return (
    <div
      className={`flex items-center mobile:items-start cursor-pointer py-8 pl-8 pr-10 mobile:p-5 w-[424px] h-[208px] mobile:w-[180px] mobile:h-[174px] mobile:flex-col bg-[linear-gradient(90deg,#DAEBFF_0%,#D5E6FF_100%)] mx-[6px] mobile:mx-0 even:bg-[linear-gradient(90deg,#D4DAFF_0%,#D2D0FF80_100%)] ${className} `}
      onClick={() => {
        window.open(jumpLink || link, '_blank');
      }}
    >
      <Image
        src={logo}
        loading="lazy"
        width={72}
        height={72}
        alt="logo"
        className="!size-[72px] mr-8 flex-shrink-0 !bg-transparent mobile:!size-12 mobile:mr-0 mobile:mb-[14px]"
      ></Image>
      <p className="text-2xl line-clamp-3 text-[#121C59] mobile:text-base font-300">
        {caseText}
      </p>
    </div>
  );
};

interface MarqueeContainerProps {
  list: IAiForGoodItem[];
  direction?: 'left' | 'right';
}

const MarqueeContainer = ({
  list,
  direction = 'left',
}: MarqueeContainerProps) => {
  return (
    <div className="h-[208px] mb-3 last:mb-0">
      <Marquee className="w-full" speed={20} pauseOnHover direction={direction}>
        <div
          className="w-full overflow-hidden grid"
          style={{
            gridTemplateColumns: `repeat(${list.length}, minmax(0, 1fr))`,
          }}
        >
          {list?.map((item, index) => (
            <AiForGoodItem item={item} key={index}></AiForGoodItem>
          ))}
        </div>
      </Marquee>
    </div>
  );
};

const AiForGoodMobile = ({ list }: { list: IAiForGoodItem[] }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  return (
    <div>
      <div
        className="grid grid-flow-col grid-rows-2 gap-3 overflow-x-auto scrollbar-hidden px-5"
        ref={scrollRef}
      >
        {list.map((item) => (
          <AiForGoodItem
            item={item}
            key={item.id}
            className="mobile:w-[180px] mobile:h-[101px]"
          ></AiForGoodItem>
        ))}
      </div>
      <CustomScrollBar scrollRef={scrollRef}></CustomScrollBar>
    </div>
  );
};

const AiForGoodSection = ({
  data,
  title,
}: {
  data: IAiForGoodItem[];
  title: string;
}) => {
  const [leftList, rightList] = useMemo(() => {
    let leftList = data.slice(0, data.length / 2);
    let rightList = data.slice(data.length / 2);
    // 如果数据不够15个，则重复
    while (leftList.length <= 15) {
      leftList = leftList.concat(leftList);
    }
    // 如果数据不够15个，则重复
    while (rightList.length <= 15) {
      rightList = rightList.concat(rightList);
    }
    return [leftList, rightList];
  }, [data]);

  return (
    <SectionContainer title={title} childrenFullWidth>
      <div className="mobile:hidden ">
        <MarqueeContainer list={leftList} />
        <MarqueeContainer list={rightList} direction="right" />
      </div>
      <div className="hidden mobile:block">
        <AiForGoodMobile list={data}></AiForGoodMobile>
      </div>
    </SectionContainer>
  );
};

export default AiForGoodSection;
